console.log("BEV RESERVATION JS LOADED - V3 QUICK ADD UNIVERSEL");

const BEV_RESERVATIONS_KEY = "bev_reservations";
let bevCartClearing = false;
let bevReservationSyncRunning = false;
let bevReservationSyncTimer = null;

function bevFormatTime(seconds){
  const min = Math.floor(seconds / 60);
  const sec = seconds % 60;
  return `${min} min ${sec < 10 ? "0" : ""}${sec} sec`;
}

function bevGetEndTime(expiresAt){
  if(!expiresAt) return 0;
  return new Date(expiresAt.replace(" ", "T")).getTime();
}

function bevGetReservations(){
  try{
    return JSON.parse(localStorage.getItem(BEV_RESERVATIONS_KEY) || "{}");
  }catch(e){
    return {};
  }
}

function bevSaveReservations(reservations){
  localStorage.setItem(BEV_RESERVATIONS_KEY, JSON.stringify(reservations));
}

function bevSetReservation(variantId, expiresAt){
  if(!variantId || !expiresAt) return;

  const reservations = bevGetReservations();
  reservations[String(variantId)] = expiresAt;
  bevSaveReservations(reservations);

  localStorage.setItem("bev_reservation_expires_at", expiresAt);
}

function bevRemoveReservation(variantId){
  const reservations = bevGetReservations();
  delete reservations[String(variantId)];
  bevSaveReservations(reservations);

  const remainingDates = Object.values(reservations);

  if(remainingDates.length){
    const nearest = remainingDates.sort((a, b) => bevGetEndTime(a) - bevGetEndTime(b))[0];
    localStorage.setItem("bev_reservation_expires_at", nearest);
  }else{
    localStorage.removeItem("bev_reservation_expires_at");
  }
}

function bevGetNearestReservation(){
  const reservations = bevGetReservations();
  const entries = Object.entries(reservations)
    .filter(([variantId, expiresAt]) => bevGetEndTime(expiresAt) > Date.now())
    .sort((a, b) => bevGetEndTime(a[1]) - bevGetEndTime(b[1]));

  return entries.length ? { variantId: entries[0][0], expiresAt: entries[0][1] } : null;
}

function bevCleanExpiredReservations(){
  const reservations = bevGetReservations();
  let changed = false;

  Object.entries(reservations).forEach(([variantId, expiresAt]) => {
    if(bevGetEndTime(expiresAt) <= Date.now()){
      delete reservations[variantId];
      changed = true;
    }
  });

  if(changed){
    bevSaveReservations(reservations);
  }

  const nearest = bevGetNearestReservation();

  if(nearest){
    localStorage.setItem("bev_reservation_expires_at", nearest.expiresAt);
  }else{
    localStorage.removeItem("bev_reservation_expires_at");
  }
}

function bevClosePopup(popup){
  popup.classList.remove("is-visible");
}

function bevShowReservationPopup(message, expiresAt){
  let popup = document.querySelector(".bev-reservation-popup:not(.bev-simple-popup)");

  if(!popup){
    popup = document.createElement("div");
    popup.className = "bev-reservation-popup";
    popup.innerHTML = `
      <div class="bev-reservation-overlay"></div>
      <div class="bev-reservation-modal">
        <button class="bev-reservation-close" type="button">×</button>
        <div class="bev-reservation-icon">⏳</div>
        <h3>Cet article est déjà réservé</h3>
        <p></p>
        <div class="bev-reservation-note">
          Disponible dans : <strong class="bev-popup-timer">-- min -- sec</strong>
        </div>
        <button class="bev-reservation-ok" type="button">OK, j'ai compris</button>
      </div>
    `;
    document.body.appendChild(popup);
  }

  popup.querySelector("p").textContent =
    message || "Une autre cliente a déjà ajouté cet article à son panier.";

  popup.classList.add("is-visible");

  const timerEl = popup.querySelector(".bev-popup-timer");

  if(expiresAt && timerEl){
    const endTime = bevGetEndTime(expiresAt);

    const interval = setInterval(() => {
      const remaining = Math.max(0, Math.floor((endTime - Date.now()) / 1000));
      timerEl.textContent = bevFormatTime(remaining);

      if(remaining <= 0){
        clearInterval(interval);
        bevClosePopup(popup);
        window.location.reload();
      }
    }, 1000);
  }

  popup.querySelector(".bev-reservation-close").onclick = () => bevClosePopup(popup);
  popup.querySelector(".bev-reservation-ok").onclick = () => bevClosePopup(popup);
  popup.querySelector(".bev-reservation-overlay").onclick = () => bevClosePopup(popup);
}

function bevShowSimplePopup(title, message){
  let popup = document.querySelector(".bev-simple-popup");

  if(!popup){
    popup = document.createElement("div");
    popup.className = "bev-reservation-popup bev-simple-popup";
    popup.innerHTML = `
      <div class="bev-reservation-overlay"></div>
      <div class="bev-reservation-modal">
        <button class="bev-reservation-close" type="button">×</button>
        <div class="bev-reservation-icon">💕</div>
        <h3></h3>
        <p></p>
        <button class="bev-reservation-ok" type="button">OK, j'ai compris</button>
      </div>
    `;
    document.body.appendChild(popup);
  }

  popup.querySelector("h3").textContent = title;
  popup.querySelector("p").textContent = message;

  popup.classList.add("is-visible");

  popup.querySelector(".bev-reservation-close").onclick = () => bevClosePopup(popup);
  popup.querySelector(".bev-reservation-ok").onclick = () => bevClosePopup(popup);
  popup.querySelector(".bev-reservation-overlay").onclick = () => bevClosePopup(popup);
}

function bevGetVariantIdFromCartLine(line){
  if(line?.dataset?.key){
    return line.dataset.key.split(":")[0];
  }

  const selector = line?.querySelector("[data-variant-id]");
  if(selector?.dataset?.variantId){
    return selector.dataset.variantId;
  }

  return null;
}

function bevGetProductNameFromCartLine(line){
  return (
    line.querySelector(".cart-items__title")?.textContent?.trim() ||
    line.querySelector("a")?.textContent?.trim() ||
    "Article"
  );
}

function bevRenderLineTimers(){
  const reservations = bevGetReservations();

  document.querySelectorAll("tr[data-key]").forEach(line => {
    const variantId = bevGetVariantIdFromCartLine(line);
    if(!variantId) return;

    line.querySelectorAll(".bev-line-reservation-timer").forEach(el => el.remove());

    const expiresAt = reservations[String(variantId)];
    if(!expiresAt) return;

    const detailsCell = line.querySelector(".cart-items__details") || line.querySelector("td");
    if(!detailsCell) return;

    const timer = document.createElement("div");
    timer.className = "bev-line-reservation-timer";
    timer.dataset.bevVariantId = variantId;
    timer.innerHTML = `
      ⏳ Réservé encore
      <strong>-- min -- sec</strong>
    `;

    detailsCell.appendChild(timer);
  });
}

function bevUpdateLineTimers(){
  const reservations = bevGetReservations();

  document.querySelectorAll(".bev-line-reservation-timer").forEach(timer => {
    const variantId = timer.dataset.bevVariantId;
    const expiresAt = reservations[String(variantId)];

    if(!expiresAt){
      timer.remove();
      return;
    }

    const remaining = Math.max(0, Math.floor((bevGetEndTime(expiresAt) - Date.now()) / 1000));
    const strong = timer.querySelector("strong");

    if(strong){
      strong.textContent = bevFormatTime(remaining);
    }

    if(remaining <= 0){
      timer.remove();
    }
  });
}

function bevRenderGlobalTimer(){
  const nearest = bevGetNearestReservation();
  const boxes = document.querySelectorAll(".bev-cart-reservation-timer");

  boxes.forEach(box => {
    if(!nearest){
      box.style.display = "none";
      return;
    }

    box.style.display = "block";

    const value = box.querySelector(".bev-cart-timer-value");
    if(value){
      const remaining = Math.max(0, Math.floor((bevGetEndTime(nearest.expiresAt) - Date.now()) / 1000));
      value.textContent = bevFormatTime(remaining);
    }
  });
}

function bevRefreshTimers(){
  /*
   * Ne pas supprimer ici les réservations expirées
   * du localStorage.
   *
   * bevClearExpiredReservations() doit d'abord
   * les détecter afin de retirer les articles
   * correspondants du panier Shopify.
   */
  bevRenderLineTimers();
  bevUpdateLineTimers();
  bevRenderGlobalTimer();
}

function bevOpenCartDrawer(){
  document.dispatchEvent(new CustomEvent("cart:open"));

  setTimeout(() => {
    const cartIcon = document.querySelector(
      'button[data-testid="cart-drawer-trigger"], button[aria-label*="Panier"], button[aria-label*="panier"], button[aria-label*="Cart"], button[aria-label*="cart"], a[href="/cart"]'
    );

    if(cartIcon){
      cartIcon.click();
    }
  }, 50);
}

async function bevReleaseReservation(variantId){
  const sessionId = localStorage.getItem("bev_reservation_session");
  if(!sessionId || !variantId) return;

  try{
    const response = await fetch(window.BEV_RESERVATION_API + "/release.php", {
      method: "POST",
      keepalive: true,
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        variant_id: variantId,
        session_id: sessionId
      })
    });

    const data = await response.json();
    console.log("BEV release response", data);

    bevRemoveReservation(variantId);

    setTimeout(() => {
      bevRefreshTimers();
    }, 500);

  }catch(error){
    console.error("Erreur libération réservation", error);
  }
}

function bevGetVariantIdFromRemoveButton(removeBtn){
  const line = removeBtn.closest("tr[data-key]");

  if(line && line.dataset.key){
    return line.dataset.key.split(":")[0];
  }

  const selector = removeBtn
    .closest(".cart-items__quantity-controls")
    ?.querySelector("[data-variant-id]");

  if(selector && selector.dataset.variantId){
    return selector.dataset.variantId;
  }

  return null;
}

async function bevRemoveExpiredCartLines(){
  const reservations = bevGetReservations();
  const expiredVariantIds = Object.entries(reservations)
    .filter(([variantId, expiresAt]) => bevGetEndTime(expiresAt) <= Date.now())
    .map(([variantId]) => variantId);

  if(!expiredVariantIds.length) return false;

  const cartResponse = await fetch("/cart.js");
  const cart = await cartResponse.json();

  let changed = false;

  for(const item of cart.items){
    if(expiredVariantIds.includes(String(item.variant_id))){
      await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: item.key,
          quantity: 0
        })
      });

      bevRemoveReservation(item.variant_id);
      changed = true;
    }
  }

  return changed;
}

async function bevClearExpiredReservations(){
  if(bevCartClearing) return;

  const reservations = bevGetReservations();

  const expiredVariantIds = Object.entries(reservations)
    .filter(([variantId, expiresAt]) => bevGetEndTime(expiresAt) <= Date.now())
    .map(([variantId]) => String(variantId));

  if(!expiredVariantIds.length) return;

  bevCartClearing = true;

  try{
    const sessionId = localStorage.getItem("bev_reservation_session");

    const cartResponse = await fetch("/cart.js");
    const cart = await cartResponse.json();

    for(const item of cart.items){
      if(expiredVariantIds.includes(String(item.variant_id))){
        await fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            id: item.key,
            quantity: 0
          })
        });

        if(sessionId){
          await fetch(window.BEV_RESERVATION_API + "/release.php", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              variant_id: item.variant_id,
              session_id: sessionId
            })
          });
        }

        bevRemoveReservation(item.variant_id);
      }
    }

    window.location.reload();

  }catch(error){
    console.error("Erreur suppression article expiré", error);
    bevCartClearing = false;
  }
}

async function bevCheckCartReservations(){

  const sessionId = localStorage.getItem("bev_reservation_session");
  if(!sessionId) return;

  try{

    const cartResponse = await fetch("/cart.js");
    const cart = await cartResponse.json();

    let changed = false;

    const reservations = bevGetReservations();

    for(const item of cart.items){
      if(!reservations[String(item.variant_id)]){
  continue;}

      const response = await fetch(
        window.BEV_RESERVATION_API + "/check.php",
        {
          method: "POST",
          headers:{
            "Content-Type":"application/json"
          },
          body: JSON.stringify({
            variant_id: item.variant_id,
            session_id: sessionId
          })
        }
      );

      const data = await response.json();

      if(!data.success){

        console.log("BEV réservation expirée :", item.variant_id);

        await fetch("/cart/change.js",{
          method:"POST",
          headers:{
            "Content-Type":"application/json"
          },
          body:JSON.stringify({
            id:item.key,
            quantity:0
          })
        });

        await fetch(window.BEV_RESERVATION_API + "/release.php", {
  method: "POST",
  headers:{
    "Content-Type":"application/json"
  },
  body: JSON.stringify({
    variant_id: item.variant_id,
    session_id: sessionId
  })
});

        bevRemoveReservation(item.variant_id);
        changed = true;
      }
    }

    if(changed){
      window.location.reload();
    }

  }catch(error){
    console.error("Erreur vérification panier :", error);
  }

}


/**
 * Compare les réservations locales avec le vrai contenu du panier Shopify.
 * Toute variante réservée qui n'est plus présente dans /cart.js est libérée.
 */
async function bevSyncReservationsWithCart(){
  if(bevReservationSyncRunning) return;

  const reservations = bevGetReservations();
  const reservedVariantIds = Object.keys(reservations);

  if(!reservedVariantIds.length) return;

  const sessionId = localStorage.getItem("bev_reservation_session");
  if(!sessionId) return;

  bevReservationSyncRunning = true;

  try{
    const cartResponse = await fetch("/cart.js", {
      method: "GET",
      headers: {
        "Accept": "application/json"
      },
      cache: "no-store"
    });

    if(!cartResponse.ok){
      throw new Error("Impossible de lire le panier Shopify");
    }

    const cart = await cartResponse.json();

    const cartVariantIds = new Set(
      (cart.items || []).map(item => String(item.variant_id))
    );

    const missingVariantIds = reservedVariantIds.filter(
      variantId => !cartVariantIds.has(String(variantId))
    );

    for(const variantId of missingVariantIds){
      console.log(
        "BEV réservation absente du panier, libération :",
        variantId
      );

      await bevReleaseReservation(variantId);
    }

    bevRefreshTimers();

  }catch(error){
    console.error(
      "Erreur synchronisation réservations / panier :",
      error
    );
  }finally{
    bevReservationSyncRunning = false;
  }
}

/**
 * Évite plusieurs contrôles simultanés pendant les mises à jour AJAX du panier.
 */
function bevScheduleReservationSync(delay = 700){
  clearTimeout(bevReservationSyncTimer);

  bevReservationSyncTimer = setTimeout(() => {
    bevSyncReservationsWithCart();
  }, delay);
}

function bevGetProductHandleFromQuickAdd(button){
  const scope = button.closest(
    "[data-product-handle], .card, .product-card, .product-card-wrapper, li, .grid__item"
  );

  if(scope?.dataset?.productHandle){
    return scope.dataset.productHandle;
  }

  const link =
    scope?.querySelector('a[href*="/products/"]') ||
    button.closest('a[href*="/products/"]') ||
    button.closest("form")?.querySelector('a[href*="/products/"]');

  if(!link) return null;

  try{
    const url = new URL(link.href);
    const parts = url.pathname.split("/products/");
    if(!parts[1]) return null;
    return parts[1].split("/")[0].split("?")[0];
  }catch(error){
    return null;
  }
}

async function bevGetInventoryForVariant(variantId, button, form){

  const inventoryMapHolder =
  button.closest("product-form-component") ||
  form.closest("product-form-component");

if(inventoryMapHolder?.dataset?.bevInventoryMap){
  try{
    const inventoryMap = JSON.parse("{" + inventoryMapHolder.dataset.bevInventoryMap + "}");
    if(typeof inventoryMap[String(variantId)] !== "undefined"){
      return Number(inventoryMap[String(variantId)]);
    }
  }catch(error){
    console.warn("BEV inventory map invalide", error);
  }
}
  const inventoryRaw =
    button.dataset.bevInventory ||
    form.dataset.bevInventory ||
    button.closest("[data-bev-product-inventory]")?.dataset.bevProductInventory ||
    document.querySelector("[data-bev-product-inventory]")?.dataset.bevProductInventory ||
    "";

  if(inventoryRaw !== ""){
    const inventory = Number(inventoryRaw);
    if(!Number.isNaN(inventory)){
      return inventory;
    }
  }

  let handle = bevGetProductHandleFromQuickAdd(button);

if(!handle){
  const productUrl =
    button.closest("product-form-component")?.dataset?.productUrl ||
    form.closest("product-form-component")?.dataset?.productUrl;

  if(productUrl){
    handle = productUrl.split("/products/")[1]?.split("?")[0]?.split("/")[0] || null;
  }
}

  if(!handle){
    return null;
  }

  try{
    const response = await fetch(`/products/${handle}.js`, {
      method: "GET",
      headers: {
        "Accept": "application/json"
      }
    });

    if(!response.ok){
      return null;
    }

    const product = await response.json();
    const variant = product.variants?.find(v => String(v.id) === String(variantId));

    if(!variant){
      return null;
    }

    if(typeof variant.inventory_quantity === "number"){
      return variant.inventory_quantity;
    }

    return null;

  }catch(error){
    console.warn("BEV impossible de lire le stock variant", error);
    return null;
  }
}

async function bevAddToCartWithoutReservation(formData){
  const addResponse = await fetch("/cart/add.js", {
    method: "POST",
    body: formData
  });

  if(!addResponse.ok){
    throw new Error("Erreur ajout panier normal");
  }

  sessionStorage.setItem("bev_open_cart_after_reload", "1");

  setTimeout(() => {
    window.location.reload();
  }, 100);
}


document.addEventListener("click", async function(e){
  const button = e.target.closest(
    [
      ".add-to-cart-button",
      'button[name="add"]',
      "[data-add-to-cart]",
      'product-form-component button[type="submit"]',
      'form[action*="/cart/add"] button[type="submit"]'
    ].join(",")
  );

  if(!button) return;

    /*
   * Sécurité boutique fermée :
   * même si l'overlay n'est pas visible,
   * aucun ajout panier ne doit être possible.
   */
  if(window.BEV_STORE_IS_CLOSED === true){
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    console.warn(
      "BEV : ajout panier bloqué car la boutique est fermée."
    );

    return false;
  }

  // On ignore le bouton "Choisir"
  if(
    button.classList.contains("quick-add__button--choose")
    || button.matches('[data-quick-add-choose]')
  ){
    return;
  }

  /*
   * Le sélecteur précédent exigeait exactement action="/cart/add".
   * Certains produits du thème Atelier utilisent une URL localisée,
   * absolue ou légèrement différente. action*="/cart/add" les couvre tous.
   */
  const form = button.closest('form[action*="/cart/add"]');

  if(!form){
    console.warn(
      "BEV ajout rapide non intercepté : formulaire /cart/add introuvable",
      button
    );
    return;
  }

  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  const formData = new FormData(form);
  const variantId =
    formData.get("id")
    || button.dataset.variantId
    || form.querySelector('[name="id"]')?.value
    || null;

  if(!variantId){
    console.error(
      "BEV réservation impossible : variant_id introuvable",
      {
        button,
        form
      }
    );

    bevShowSimplePopup(
      "Article non réservé",
      "Cet article n'a pas pu être réservé. Merci de réessayer depuis sa fiche produit."
    );

    return false;
  }

  formData.set("id", String(variantId));
  formData.set("quantity", "1");

  const inventory = await bevGetInventoryForVariant(variantId, button, form);

  /*
   * V2 STOCK INTELLIGENT :
   * On réserve tous les produits, même si le stock est supérieur à 1.
   * reserve-v2.php compare le stock Shopify avec le nombre de réservations actives.
   * Exemple : stock 4 = jusqu'à 4 clientes peuvent réserver.
   */
  const stockForReservation =
    inventory !== null && !Number.isNaN(Number(inventory)) && Number(inventory) > 0
      ? Number(inventory)
      : 1;

  let sessionId = localStorage.getItem("bev_reservation_session");

  if(!sessionId){
    sessionId = crypto.randomUUID();
    localStorage.setItem("bev_reservation_session", sessionId);
  }

  button.disabled = true;
  const originalText = button.innerHTML;
  button.innerHTML = "Vérification...";

  try{
    const cartResponse = await fetch("/cart.js");
    const cart = await cartResponse.json();

    const alreadyInCart = cart.items.some(
      item => String(item.variant_id) === String(variantId)
    );

    if(alreadyInCart){
      button.disabled = false;
      button.innerHTML = originalText;

      bevShowSimplePopup(
        "Déjà dans votre panier",
        "Cet article est déjà réservé pour vous. Vous pouvez finaliser votre commande depuis le panier."
      );

      return false;
    }

    const response = await fetch(window.BEV_RESERVATION_API + "/reserve-v2.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        variant_id: variantId,
        product_id: window.ShopifyAnalytics?.meta?.product?.id || 0,
        session_id: sessionId,
        stock: stockForReservation
      })
    });

    const data = await response.json();

    if(!data.success){
      button.innerHTML = "⏳ Réservé par une autre cliente";
      bevShowReservationPopup(data.message, data.expires_at);
      return false;
    }

    bevSetReservation(variantId, data.expires_at);

const addResponse = await fetch("/cart/add.js", {
  method: "POST",
  body: formData
});

if(!addResponse.ok){
  /*
   * La réservation a été créée en base,
   * mais Shopify a refusé l'ajout au panier.
   * On la libère immédiatement pour éviter
   * une réservation fantôme.
   */
  await bevReleaseReservation(variantId);

  button.disabled = false;
  button.innerHTML = originalText;

  bevShowSimplePopup(
    "Ajout impossible",
    "L’article n’a pas pu être ajouté au panier. Sa réservation a été annulée, vous pouvez réessayer."
  );

  return false;
}

    button.disabled = false;
    button.innerHTML = originalText;

    sessionStorage.setItem("bev_open_cart_after_reload", "1");

    setTimeout(() => {
      window.location.reload();
    }, 100);

}catch(error){
  console.error(error);

  /*
   * Sécurité :
   * si une réservation a été enregistrée localement,
   * on tente de la libérer avant d'afficher l'erreur.
   */
  const reservations = bevGetReservations();

  if(reservations[String(variantId)]){
    await bevReleaseReservation(variantId);
  }

  button.disabled = false;
  button.innerHTML = originalText;

  bevShowSimplePopup(
    "Une erreur est survenue",
    "L’article n’a pas été ajouté au panier. Sa réservation a été libérée, merci de réessayer."
  );
}

  return false;
}, true);

document.addEventListener("click", function(e){
  const cartControl = e.target.closest(
    [
      ".cart-items__remove",
      "cart-remove-button",
      "[data-cart-remove]",
      "[data-remove]",
      'a[href*="/cart/change"][href*="quantity=0"]',
      'button[name="minus"]',
      "[data-quantity-minus]",
      ".quantity__button",
      ".cart-item__remove"
    ].join(",")
  );

  if(!cartControl) return;

  /*
   * Le thème peut retirer un article de plusieurs façons.
   * Après la mise à jour AJAX, on compare le vrai panier Shopify
   * avec les réservations locales.
   */
  bevScheduleReservationSync(900);
}, true);

document.addEventListener("change", function(e){
  const quantityInput = e.target.closest(
    [
      'input[name="updates[]"]',
      'input[name="quantity"]',
      ".quantity__input",
      "[data-cart-quantity]"
    ].join(",")
  );

  if(!quantityInput) return;

  bevScheduleReservationSync(900);
}, true);

/*
 * Le thème Atelier peut remplacer tout le contenu du tiroir du panier.
 * Ce contrôle détecte aussi ces mises à jour.
 */
const bevCartObserver = new MutationObserver(() => {
  if(Object.keys(bevGetReservations()).length){
    bevScheduleReservationSync(800);
  }
});

bevCartObserver.observe(document.documentElement, {
  childList: true,
  subtree: true
});

document.addEventListener("click", function(e){
  const cartButton = e.target.closest(
    'button[data-testid="cart-drawer-trigger"], button[aria-label*="Panier"], button[aria-label*="panier"], button[aria-label*="Cart"], button[aria-label*="cart"], a[href="/cart"]'
  );

  if(!cartButton) return;

  const timerRetry = setInterval(bevRefreshTimers, 300);

  setTimeout(() => {
    clearInterval(timerRetry);
  }, 3000);
}, true);

document.addEventListener("DOMContentLoaded", () => {
  bevCheckCartReservations();
  bevScheduleReservationSync(1200);
  if(localStorage.getItem("bev_reservation_expires_at") && !localStorage.getItem(BEV_RESERVATIONS_KEY)){
    const legacy = localStorage.getItem("bev_reservation_expires_at");
    console.warn("Ancien timer détecté. Il sera ignoré en mode multi-timers :", legacy);
    localStorage.removeItem("bev_reservation_expires_at");
  }

  if(sessionStorage.getItem("bev_open_cart_after_reload") === "1"){
    sessionStorage.removeItem("bev_open_cart_after_reload");

    setTimeout(() => {
      bevOpenCartDrawer();
    }, 150);

    const timerRetry = setInterval(bevRefreshTimers, 300);

    setTimeout(() => {
      clearInterval(timerRetry);
    }, 3000);
  }

  setInterval(bevRefreshTimers, 1000);
  setInterval(bevClearExpiredReservations, 1000);

  setInterval(() => {
    if(Object.keys(bevGetReservations()).length){
      bevSyncReservationsWithCart();
    }
  }, 5000);
});